import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PipeFunction} from '../../common/pipes/pipe-function.pipe';
import {DragAndDropDirective} from '../../common/directives/drag-and-drop.directive';
import {SafePipe} from '../../common/pipes/safe.pipe';
import {AutofocusDirective} from '../../common/directives/mc-autofocus.directive';
import {ExpiredCardDatePipe} from '../../common/pipes/expired-date.pipe';
import {TransformCardNamePipe} from '../../common/pipes/transform-card-name.pipe';

@NgModule({
  declarations: [
    PipeFunction,
    DragAndDropDirective,
    AutofocusDirective,
    SafePipe,
    ExpiredCardDatePipe,
    TransformCardNamePipe,
  ],
  imports: [CommonModule],
  exports: [
    PipeFunction,
    DragAndDropDirective,
    AutofocusDirective,
    SafePipe,
    ExpiredCardDatePipe,
    TransformCardNamePipe,
  ],
})
export class SharedModule {}
